import React from 'react'
import PropTypes from 'prop-types'
import ContentfulClient from '../../contentful'
import Layout from '../../components/layout'
import Banner from '../../components/banner'
import { ABOUT_US_CONTENTFUL_ID } from '../../utils/vars'
// import BottomInfo from '../../components/bottominfo'

import styles from './AboutUs.module.scss'
import MetaHeaders from '../../components/metaheaders'

const AboutUs = ({
    metaTitle,
    metaDescription,
    text1,
    text2,
    text3,
}) => (
    <>
        <Banner />
        <MetaHeaders
            title={metaTitle}
            description={metaDescription}
        />
        <Layout>
            <div className={styles.aboutUs}>
                <div className={styles.wrapper}>
                    <div className={styles.fontWrapper}>
                        <span><strong>what is urbancoolab?</strong></span>
                        <p>
                            {text1}
                        </p>
                        <p>
                            {text2}
                        </p>
                        <p>
                            {text3}
                        </p>
                    </div>
                </div>
                {/* <BottomInfo desc={footerInfo} /> */}
            </div>
        </Layout>
    </>
)

AboutUs.getInitialProps = async () => {
    const res = await ContentfulClient.getEntry(ABOUT_US_CONTENTFUL_ID)
    return {
        ...res.fields,
        bannerImage: res.fields.bannerImage.fields.file.url,
    }
}

AboutUs.propTypes = {
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    text1: PropTypes.string.isRequired,
    text2: PropTypes.string.isRequired,
    text3: PropTypes.string.isRequired,
    // footerInfo: PropTypes.string.isRequired,
}

export default AboutUs
